import React, { useRef, useEffect } from 'react';
import { Viewer } from '@toast-ui/react-editor';
import '@toast-ui/editor/dist/toastui-editor-viewer.css';

const ToastViewer = ({
  content,
  className = "",
  style = {}
}) => {
  const viewerRef = useRef(null);

  useEffect(() => {
    if (viewerRef.current && content !== undefined) {
      const viewerInstance = viewerRef.current.getInstance();
      viewerInstance.setMarkdown(content || '');
    }
  }, [content]);

  return (
    <div className={`toast-viewer-container ${className}`} style={style}>
      <Viewer
        ref={viewerRef}
        initialValue={content || ''}
      />
    </div>
  );
};

export default ToastViewer;
